<template>
    <aside class="theSidebar bg-white">
        <div class="logoHolder">
            <Logo />
        </div>

        <ul class="menuItems">
            <li class="item">
                <router-link
                    :class="{
                        'router-link-active': $route.name === 'home',
                        notActive: $route.path !== '/'
                    }"
                    to="/"
                    class="link"
                >
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/></svg>
                    <span class="label">
                        Dashboard
                    </span>
                </router-link>
            </li>

            <li class="item">
                <router-link to="/media-library" class="link">
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                    <span class="label">
                        Media library
                    </span>
                </router-link>
            </li>

            <li class="item">
                <router-link to="/products" class="link hasChilds">
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"/></svg>
                    <span class="label">
                        Products
                    </span>
                    <svg svg-inline="" class="arrowIcon" focusable="false" role="presentation" fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>
                </router-link>
                <ul class="subMenu">
                    <li class="subMenuItem">
                        <router-link
                            :class="{
                                notActive: pathIncludes([
                                    'categories',
                                    'sort-order'
                                ])
                            }"
                            to="/products"
                            class="link subMenuLink"
                        >
                            <span class="label">
                                Products
                            </span>
                        </router-link>
                    </li>
                    <li class="subMenuItem">
                        <router-link
                            to="/products/sort-order"
                            class="link subMenuLink"
                        >
                            <span class="label">
                                Sort products
                            </span>
                        </router-link>
                    </li>
                    <li class="subMenuItem">
                        <router-link
                            to="/products/categories"
                            class="link subMenuLink"
                        >
                            <span class="label">
                                Categories
                            </span>
                        </router-link>
                    </li>
                </ul>
            </li>

            <li class="item">
                <router-link to="/documents" class="link hasChilds">
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
                    <span class="label">
                        Documents
                    </span>
                    <svg svg-inline="" class="arrowIcon" focusable="false" role="presentation" fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>
                </router-link>
                <ul class="subMenu">
                    <li class="subMenuItem">
                        <router-link
                            :class="{ notActive: pathIncludes(['categories']) }"
                            to="/documents"
                            class="link subMenuLink"
                        >
                            <span class="label">
                                Documents
                            </span>
                        </router-link>
                    </li>
                    <li class="subMenuItem">
                        <router-link
                            to="/documents/categories"
                            class="link subMenuLink"
                        >
                            <span class="label">
                                Categories
                            </span>
                        </router-link>
                    </li>
                </ul>
            </li>

            <li class="item">
                <router-link to="/endpoints" class="link">
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16"/><circle cx="5" cy="19" r="1"/></svg>
                    <span class="label">
                        Endpoints
                    </span>
                </router-link>
            </li>

            <li class="item">
                <router-link to="/users" class="link">
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    <span class="label">
                        Users
                    </span>
                </router-link>
            </li>
        </ul>

        <button class="link w-full" type="button" name="button" @click="logout">
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
            <span class="label">
                Log out
            </span>
        </button>
    </aside>
</template>

<script>
import Logo from "../ui/Logo.vue";

export default {
    components: {
        Logo
    },
    methods: {
        pathIncludes(paths) {
            const { fullPath } = this.$route;
            return paths.find(path => fullPath.includes(path));
        },
        logout() {
            this.$store.commit("auth/LOGOUT");
            this.$router.push({ name: "login" });
        }
    }
};
</script>

<style lang="postcss" scoped>
.theSidebar {
    position: fixed;
    width: 300px;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 100;
    box-shadow: var(--shadow);
    @media (--smallDesktop) {
        width: 260px;
    }
    @media (--laptop) {
        width: 200px;
    }
}
.logoHolder {
    margin: 25px auto;
    width: 120px;
    height: auto;
    @media (--laptop) {
        width: 100px;
    }
}
.menuItems {
    margin-bottom: 20px;
    border-bottom: 1px solid #e8edee;
    list-style: none;
    @media (--smallDesktop) {
        margin-bottom: 18px;
    }
}

.link {
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 0.25px;
    color: var(--primaryTextColor);
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 25px;
    @media (--smallDesktop) {
        font-size: 16px;
        padding: 18px 20px;
    }
    @media (--laptop) {
        font-size: 15px;
        padding: 14px 15px;
    }
    &:hover {
        color: var(--primary);
    }
    &.router-link-active:not(.notActive) {
        background-color: var(--primary100);
        color: var(--primary);
    }
    &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 4px;
        height: 100%;
        background-color: var(--primary);
        transition: var(--slowTrans);
        transform: scaleX(0);
        transform-origin: left;
    }
    &.router-link-active:not(.notActive)::after {
        transform: scaleX(1);
    }
    &.hasChilds {
        padding-right: 50px;
        @media (--laptop) {
            padding-right: 40px;
        }
    }
}
.icon {
    width: 20px;
    height: 20px;
    line-height: 0;
    margin-right: 15px;
    flex-shrink: 0;
    @media (--smallDesktop) {
        width: 18px;
        height: 18px;
        margin-right: 12px;
    }
    @media (--laptop) {
        width: 16px;
        height: 16px;
    }
}
.arrowIcon {
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 20px;
    width: 24px;
    height: 24px;
    transition: var(--normalTrans);
    color: var(--primary);
    @media (--smallDesktop) {
        margin-top: -10px;
        right: 20px;
        width: 20px;
        height: 20px;
    }
    @media (--laptop) {
        width: 18px;
        height: 18px;
        right: 15px;
        margin-top: -9px;
    }
}
.router-link-active .arrowIcon {
    transform: rotate(-0.5turn);
}
.subMenu {
    background-color: var(--primary100);
    padding: 5px 0 20px;
    display: none;
    list-style: none;
    @media (--laptop) {
        padding: 2px 0 10px;
    }
}
.router-link-active + .subMenu {
    display: block;
}
.subMenuLink {
    padding: 10px;
    padding-left: 60px;
    @media (--smallDesktop) {
        padding-left: 50px;
    }
    @media (--laptop) {
        padding-left: 43px;
    }
    &::after {
        display: none;
    }
    &.router-link-active {
        background-color: transparent !important;
    }
}
@keyframes sidebarAnimateIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>
